
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[language]/[location]/pooja/[slug]",
      function () {
        return require("private-next-pages/[language]/[location]/pooja/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[language]/[location]/pooja/[slug]"])
      });
    }
  